module.exports = __webpack_public_path__ + "img/master-entry.9736469f.svg";